import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { TourService } from 'src/app/services/tour.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from 'firebase/auth';
import { User as AppUser } from 'src/app/entities/user.model';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss']
})
export class WelcomePage implements OnInit {

  targetLang: string = '';
  user: AppUser | null = null;

  welcomes = [
    { text: "Welcome!", lang: "english" },
    { text: "欢迎!", lang: "chinese" },
    { text: "مرحبا!", lang: "arabic" },
    { text: "Bem-vindo!", lang: "portuguese" },
    { text: "Bienvenue!", lang: "french" },
    { text: "Willkommen!", lang: "german" },
    { text: "¡Bienvenido!", lang: "spanish" },
    { text: "ようこそ!", lang: "japanese" },
    { text: "Добро пожаловать!", lang: "russian" },
    { text: "स्वागत!", lang: "hindi" }
  ];

  ngOnInit(): void {
    document.title = 'Welcome';
    this.authService.currentUser$.subscribe(user => {
      if (user && user.targetLanguage && user.nativeLanguage) {
        this.user = user;
        this.targetLang = user.targetLanguage;
      } else {
        // Don't call translateWelcome if user is not ready
        this.user = null;
        this.targetLang = '';
      }
    });
  }

  constructor(private router: Router, private authService: AuthService, 
    private userService: UserService, private tourService: TourService,
    private translateService: TranslateService) {}

  goToExampleArticle() {
    // Get user's target language and navigate to the static article page
        this.tourService.startTour(this.targetLang);
  }
}